// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"323":"aaa5ba7b","453":"0693dd4c","667":"8c78d18b","977":"73c8b229"}[chunkId] + ".chunk.js";
};